import { translateSessionStatus, useTranslation } from '@eon/i18n';

/**
 * All charging_sessions.status values accepted by the OM/admin session list API
 * (see eon-backend migrations + domain/session). Legacy spellings included for
 * older rows / normalized client types.
 */
export const SESSION_STATUS_FILTER_VALUES = [
  'preparing',
  'charging',
  'suspendedev',
  'suspendedevse',
  'finishing',
  'completed',
  'faulted',
  'cancelled',
  'started',
  'stopped',
  'stopping',
  'aborted',
] as const;

export type SessionStatusFilterValue = (typeof SESSION_STATUS_FILTER_VALUES)[number];

export function useSessionStatusFilterOptions() {
  const { t } = useTranslation();
  return [
    { value: '__all__', label: t('filters.all') },
    ...SESSION_STATUS_FILTER_VALUES.map((value) => ({
      value,
      label: translateSessionStatus(t, value),
    })),
  ];
}
